import { DefaultOpportunitiesComponent } from "./components/opportunities/templates/default/default-opportunities.component";
import { SocialOpportunitiesComponent } from "./components/opportunities/templates/social/social-opportunities.component";
import { SkyOpportunitiesComponent } from "./components/opportunities/templates/sky/sky-opportunities.component";

export const oppComponentDef = {
    "opportunity-list": {
        "default": DefaultOpportunitiesComponent,
        "social": SocialOpportunitiesComponent,
        "sky": SkyOpportunitiesComponent
    }
}